import { Button } from 'primereact/button';
import { useTranslation } from 'react-i18next';

import { IPermission } from '../../../../../../../../hooks/api/permissions';
import useDialogContext from '../../../../../../../../hooks/dialog/useDialogContext';

type WithdrawPermissionButtonProps = {
  permission: IPermission;
};

const WithdrawPermissionButton = ({ permission }: WithdrawPermissionButtonProps) => {
  const { t } = useTranslation();
  const { openDialog } = useDialogContext();

  return (
    <Button
      label={t('productDetailsPage.tabs.permissionsTab.buttons.withdraw')}
      onClick={() => {
        return openDialog('withdraw-permission-dialog', {
          permission,
        });
      }}
    />
  );
};

export default WithdrawPermissionButton;
